import { useTranslation } from 'react-i18next';

import HttpCodePage from '../components/HttpCodePage';
import Illustration from './Illustration';

export default () => {
  const { t } = useTranslation();

  return (
    <HttpCodePage code="404" label={t('http.404.title')}>
      <Illustration />
    </HttpCodePage>
  );
};
